// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"cookies-consent_cookieBanner__4OH2X","cookieMessage":"cookies-consent_cookieMessage__VcGTC"};